export default function ProblemSection() {
  return (
    <section className="w-full bg-luxury-dark py-24 md:py-36 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left – image */}
          <div className="reveal order-2 lg:order-1">
            <div className="relative w-full h-[420px] md:h-[540px]">
              <img
                src="https://readdy.ai/api/search-image?query=rows%20of%20identical%20mass%20produced%20gold%20jewelry%20pieces%20displayed%20uniformly%20in%20a%20shop%20window%2C%20generic%20impersonal%20necklaces%20and%20rings%20looking%20all%20the%20same%2C%20cold%20commercial%20retail%20lighting%2C%20dark%20moody%20background%20with%20soft%20shadow%2C%20cinematic%20close-up%20photography&width=800&height=600&seq=2&orientation=landscape"
                alt="Hazır takılar"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/80 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <p className="font-serif text-white/40 text-lg italic">
                  &ldquo;Herkeste olan bir takı...&rdquo;
                </p>
              </div>
            </div>
          </div>

          {/* Right – text */}
          <div className="order-1 lg:order-2 flex flex-col gap-8">
            <div className="reveal">
              <span className="font-sans text-gold text-xs tracking-luxury uppercase">
                Sorun
              </span>
            </div>

            <h2 className="reveal reveal-delay-1 font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-snug">
              Hazır takılar
              <br />
              <em className="text-white/50 not-italic">herkese hitap eder.</em>
              <br />
              Ama sizi{' '}
              <em className="text-gold-gradient not-italic">yansıtmaz.</em>
            </h2>

            <div className="reveal reveal-delay-2 gold-line w-16" />

            <div className="reveal reveal-delay-3 flex flex-col gap-5">
              {[
                { icon: 'ri-prohibited-line', text: 'Milyonlarca kişiyle aynı tasarımı taşırsınız.' },
                { icon: 'ri-emotion-sad-line', text: 'Aldığınız takı hiçbir hikâye taşımaz.' },
                { icon: 'ri-price-tag-3-line', text: 'Fiyata göre seçim yapmak zorunda kalırsınız.' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center border border-gold/30 rounded-sm flex-shrink-0">
                    <i className={`${item.icon} text-gold text-base`} />
                  </div>
                  <p className="font-sans text-white/60 text-sm leading-relaxed pt-2">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

            <div className="reveal reveal-delay-4">
              <p className="font-serif text-xl text-gold/80 italic">
                &ldquo;Ya tam size ait bir tasarım olsaydı?&rdquo;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
